export default __webpack_public_path__ + "static/media/calendar.37d5af4b.svg";